module.exports = __webpack_public_path__ + "static/img/right_img.e347862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/right_img.png
// module id = wuzr
// module chunks = 0